exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-preview[data-v-5878ebe4] {\n  max-width: 232px;\n  padding: 8px 12px;\n  border-radius: 12px;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.08);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  white-space: pre-wrap;\n  font-family: 'Roboto', sans-serif;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n", ""]);

// exports
